import {
	SummaryJobRisksExams,
	SummaryJobProfileType,
} from 'Views/JobProfile/pages/SummaryRisk/SummaryRisk.types';
import {
	examTypes,
	frequencyTypes,
} from '../../FormRisk/components/RecommendedExams/RecommendedExams.const';

export const formatterGetSummaryJobProfile = (data: SummaryJobProfileType) => {
	const recommendedExams: SummaryJobRisksExams[] = [];
	data.jobRisks.forEach((jobRisk) => {
		jobRisk.jobRiskFactors.forEach((jobRiskFactor) => {
			jobRiskFactor?.exams?.forEach((exam) => {
				const examIndex = recommendedExams.findIndex(
					(recommendedExam) => recommendedExam.id === exam.id,
				);
				if (examIndex < 0) {
					recommendedExams.push({
						id: exam.id,
						name: exam.name,
						type: exam.type,
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						//@ts-ignore
						frequency: exam.frequency ? [exam.frequency] : [],
						images: jobRisk.imageUrl
							? [{ url: jobRisk.imageUrl, name: jobRisk.name }]
							: [],
					});
					return;
				}
				recommendedExams[examIndex] = {
					...recommendedExams[examIndex],
					type: [...recommendedExams[examIndex].type, ...exam.type],
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					frequency: [...recommendedExams[examIndex].frequency, exam.frequency],
					images: [
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						//@ts-ignore
						...recommendedExams[examIndex].images,
						jobRisk.imageUrl
							? { url: jobRisk.imageUrl, name: jobRisk.name }
							: {},
					],
				};
			});
		});
	});

	recommendedExams.forEach((recommendedExam) => {
		recommendedExam.type = Array.from(new Set(recommendedExam.type));
		recommendedExam.frequency = Array.from(new Set(recommendedExam.frequency));
		recommendedExam.images = Array.from(new Set(recommendedExam.images));
	});

	recommendedExams.forEach((recommendedExam) => {
		recommendedExam.type = recommendedExam.type.map((type) => {
			const typeFound = examTypes.find((examType) => examType.id === type);
			return typeFound ? typeFound.value : '';
		});
		recommendedExam.frequency = recommendedExam.frequency.map((frequency) => {
			const frequencyFound = frequencyTypes.find(
				(frequencyType) => frequencyType.id === frequency,
			);
			return frequencyFound ? frequencyFound.value : '';
		});
	});

	return {
		...data,
		recommendedExams,
	};
};
